import { assignmentMock } from './assignment.mock';
import { AssignmentPolicies } from './assignmentPolicies.model';

export const assignmentPoliciesMock = new AssignmentPolicies({
  crewMemberId: assignmentMock.crewMemberId,
  timestamp: '20180726095420',
  shipCode: assignmentMock.ship.code,
  signonDate: assignmentMock.signOnDate,
  policies: [
    {
      policyIdentifier: 'timeAndAttendance',
      contentVersion: 'v1',
    },
    {
      policyIdentifier: 'grievancePolicy',
      contentVersion: 'v1',
    },
  ],
});
